// extracted by mini-css-extract-plugin
export default {"check-list":"CheckList_check-list__ZovHN"};